import { render, staticRenderFns } from "./DeliveryWeightedDetail.vue?vue&type=template&id=6315e645&scoped=true&"
import script from "./DeliveryWeightedDetail.vue?vue&type=script&lang=ts&"
export * from "./DeliveryWeightedDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315e645",
  null
  
)

export default component.exports